import { PhantomWalletAdapter, BackpackWalletAdapter, SolflareWalletAdapter, TrustWalletAdapter } from './walletAdapters/index.js';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { solana, solanaDevnet, solanaTestnet } from '../utils/chains.js';
export const supportedWallets = ['phantom', 'solflare', 'trustWallet', 'backpack'];
const chainMap = {
    [solana.chainId]: WalletAdapterNetwork.Mainnet,
    [solanaDevnet.chainId]: WalletAdapterNetwork.Devnet,
    [solanaTestnet.chainId]: WalletAdapterNetwork.Testnet
};
export function createWalletAdapters(chainId) {
    return {
        phantom: new PhantomWalletAdapter(),
        trustWallet: new TrustWalletAdapter(),
        backpack: new BackpackWalletAdapter(),
        solflare: new SolflareWalletAdapter({
            network: chainMap[chainId || solana.chainId]
        })
    };
}
export function syncInjectedWallets(w3mConnectors, adapters) {
    supportedWallets.forEach(wallet => {
        if (window[wallet]) {
            w3mConnectors.push({
                id: adapters[wallet].name,
                type: 'ANNOUNCED',
                imageUrl: adapters[wallet].icon,
                name: adapters[wallet].name,
                provider: adapters[wallet]
            });
        }
    });
}
//# sourceMappingURL=walletAdapters.js.map